import React from 'react';
import { CustomSelectInput } from 'candy-commons-components';
import { Loading, useGetList } from 'react-admin';
export const DiscoverCategoryInput = (props) => {
    console.log('DiscoverCategoryInput: props::', props);
    const { data: discoverCategories, isLoading: isLoadingDiscoverCategories } =
        useGetList('discover-categories');

    if (isLoadingDiscoverCategories) {
        return <Loading />;
    }

    console.log(
        'DiscoverCategoryInput: discoverCategories::',
        discoverCategories
    );

    return (
        discoverCategories &&
        !isLoadingDiscoverCategories && (
            <CustomSelectInput
                source="category"
                label="Category"
                choices={Object.values({
                    ...discoverCategories,
                    noCategory: { id: '', categoryName: 'No category' },
                })
                    .filter((pr) => {
                        if (props?.categoryId) {
                            return (
                                !pr.categoryId ||
                                pr.categoryId == props?.categoryId
                            );
                        } else {
                            return !pr.categoryId;
                        }
                    })
                    .map((r, i) => {
                        return {
                            id: r.id,
                            name: r.categoryName,
                        };
                    })}
                disabled={props?.isEditDisabled}
            />
        )
    );
};
